module.exports = __webpack_public_path__ + "static/media/email_plane.3d2a508a.svg";